import { createLoaderImp } from '../../../../components/ozmoit/common';
import { getClassroomAvailabilityAction } from '../actions';

const {
  useLoader: useNonStructuredSectionClassroomLoader,
  LoaderProvider,
} = createLoaderImp({
  action: getClassroomAvailabilityAction,
});

function NonStructuredSectionClassroomLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return <LoaderProvider {...props}>{children}</LoaderProvider>;
}

export {
  NonStructuredSectionClassroomLoader,
  useNonStructuredSectionClassroomLoader,
};
